'use client'

import { type KeyboardEvent, useCallback, useEffect, useRef, useState } from 'react'
import { tokens } from '../theme/tokens.css'

const EXCLUDE_SET = new Set([
  'Tab',
  'Enter',
  'ArrowDown',
  'ArrowUp',
  'ArrowRight',
  'ArrowLeft',
  'Shift',
  'Alt',
  'Meta',
  'Control',
])

export function useHighlightAnimation<Element extends HTMLElement>() {
  const ref = useRef<Element | null>(null)
  const [backgroundColor, setBackgroundColor] = useState<string>(tokens.legacyColors.translucent1)

  useEffect(() => {
    if (!ref.current) return

    const elementBackgroundColor = getComputedStyle(ref.current).backgroundColor
    setBackgroundColor(elementBackgroundColor)
  }, [])

  const highlight = useCallback(
    (event?: KeyboardEvent<Element>) => {
      if (event && EXCLUDE_SET.has(event.key)) return

      ref.current?.animate(
        [
          {
            backgroundColor: tokens.colors.components.input.background.highlight,
            easing: 'cubic-bezier(0.65, 0.05, 0.36, 1)',
            offset: 0.2,
          },
          {
            backgroundColor: tokens.colors.components.input.background.highlight,
          },
          { backgroundColor, easing: 'ease-out' },
        ],
        {
          duration: 1200,
        },
      )
    },
    [ref, backgroundColor],
  )

  return { highlight, animationProps: { ref } } as const
}
